import React, { createContext, useReducer, useEffect } from "react";
import GlobalReducer from "./GlobalReducer";

//Initial State

const initialState = {
  address: { country: "Canada", province: "", city: "", postalCode: "" },
  cardType: "Standart",
  showAddressForm: false,
  test: "test from global context",
  showCardTypeForm: false,
  disableLimitBtns: false,
  showSearchBy: true,
  showLimitSearchBool: true,
  showCompanyInput: false,
  showKeywordInput: false,
  showCategoryInput: false,
  showKeywordSearch: true,
  showCompanySearch: true,
  showCategorySearch: true,
  selectedBtnStyle: { backgroundColor: "#e9ecef" },
};

//

// Create Context
export const GlobalContext = createContext(initialState);
const localStorageGlobalState = JSON.parse(localStorage.getItem("glbState"));

export const GlobalProvider = ({ children }) => {
  //Provider Component

  const [globalState, dispatch] = useReducer(
    GlobalReducer,
    localStorageGlobalState || initialState
  );

  useEffect(() => {
      if (localStorageGlobalState) {
        const repaired = { ...localStorageGlobalState };

        // Normalize missing country
        repaired.address = {
          ...repaired.address,
          country: repaired.address.country || inferCountryFromProvince(repaired.address.province)
        };

        dispatch({
          type: "GET_STATE_FROM_LOCAL",
          payload: repaired,
        });
      }
    }, []);


  useEffect(() => {
    localStorage.setItem("glbState", JSON.stringify(globalState));
  }, [globalState]);

  const showLimitSearch = () => {
    dispatch({ type: "SHOW_LIMIT_SEARCH" });
  };

  const hideLimitSearch = () => {
    dispatch({ type: "HIDE_LIMIT_SEARCH" });
  };

  const toggleLimitSearch = () => {
    dispatch({ type: "TOGGLE_LIMIT_SEARCH" });
  };

  const resetGlobalState = () => {
    dispatch({ type: "RESET_GLOBAL_STATE", payload: initialState });
  };

  const toggleAddressForm = () => {
    dispatch({ type: "TOGGLE_ADDRESS_FORM" });
  };

  const toggleLimitButtons = () => {
    dispatch({ type: "TOGGLE_LIMIT_BUTTONS" });
  };

  //// CARD TYPE
  const toggleCardTypeForm = () => {
    dispatch({ type: "TOGGLE_CARDTYPE_FORM" });
  };

  const updateCardType = ({ cardType: cardType }) => {
    dispatch({ type: "UPDATE_CARDTYPE", payload: cardType });
  };

  // INPUT FIELDS

  const toggleShowCompanyInput = () => {
    dispatch({ type: "TOGGLE_SHOW_COMPANY_INPUT" });
  };
  const toggleShowKeywordInput = () => {
    dispatch({ type: "TOGGLE_SHOW_KEYWORD_INPUT" });
  };
  const toggleShowCategoryInput = () => {
    dispatch({ type: "TOGGLE_SHOW_CATEGORY_INPUT" });
  };

  /// SEARCH
  const toggleShowKeywordSearch = () => {
    dispatch({ type: "TOGGLE_SHOW_KEYWORD_SEARCH" });
  };
  const toggleShowCategorySearch = () => {
    dispatch({ type: "TOGGLE_SHOW_CATEGORY_SEARCH" });
  };

  const toggleShowCompanySearch = () => {
    dispatch({ type: "TOGGLE_SHOW_COMPANY_SEARCH" });
  };

  const resetSearchByBtnState = () => {
    dispatch({ type: "RESET_SEARCHBY_BTN_STATE" });
  };

  ///
const updateAddress = ({ address }) => {
  const normalized = {
    ...address,
    country: address.country || inferCountryFromProvince(address.province)
  };

  console.log("📌 [updateAddress] Incoming:", address);
  console.log("📌 [updateAddress] Normalized:", normalized);

  dispatch({ type: "UPDATE_ADDRESS", payload: normalized });
  dispatch({ type: "TOGGLE_ADDRESS_FORM" });
};



  const inferCountryFromProvince = (province) => {
  console.log("🔍 [inferCountryFromProvince] Province:", province);

  const canadian = ["ON","QC","BC","AB","MB","SK","NS","NB","NL","PE","YT","NT","NU"];
  const american = [
    "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
    "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
    "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
    "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
    "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"
  ];

  if (canadian.includes(province?.toUpperCase())) {
    console.log("➡ Country inferred: CANADA");
    return "Canada";
  }

  if (american.includes(province?.toUpperCase())) {
    console.log("➡ Country inferred: USA");
    return "USA";
  
  }

  console.log("⚠ Unknown province → defaulting to Canada");
  return "Canada";
};


  return (
    <GlobalContext.Provider
      value={{
        address: globalState.address,
        cardType: globalState.cardType,
        showAddressForm: globalState.showAddressForm,
        showCardTypeForm: globalState.showCardTypeForm,
        disableLimitBtns: globalState.disableLimitBtns,
        showSearchBy: globalState.showSearchBy,
        showLimitSearchBool: globalState.showLimitSearchBool,
        showCompanyInput: globalState.showCompanyInput,
        showKeywordInput: globalState.showKeywordInput,
        showCategoryInput: globalState.showCategoryInput,
        showKeywordSearch: globalState.showKeywordSearch,
        showCompanySearch: globalState.showCompanySearch,
        showCategorySearch: globalState.showCategorySearch,
        selectedBtnStyle: globalState.selectedBtnStyle,

        showLimitSearch,
        hideLimitSearch,
        toggleLimitSearch,
        //

        resetGlobalState,
        toggleAddressForm,
        toggleCardTypeForm,
        toggleLimitButtons,
        // inputs
        toggleShowCompanyInput,
        toggleShowCategoryInput,
        toggleShowKeywordInput,
        //searchs
        toggleShowKeywordSearch,
        toggleShowCompanySearch,
        toggleShowCategorySearch,

        //

        resetSearchByBtnState,
        updateAddress,
        updateCardType,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
